"use client";

import { isDeepEqual } from "@noya-app/noya-utils";
import { useCallback, useMemo, useState } from "react";

export const useDeepState: typeof useState = (
  ...args: Parameters<typeof useState>
) => {
  const [state, _setState] = useState(...args);

  const setState = useCallback(function updater(updated: typeof state) {
    _setState((current) => {
      if (isDeepEqual(current, updated)) return current;
      return updated;
    });
  }, []);

  return useMemo(() => [state, setState], [state, setState]);
};
